import { Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import MobileBottomNav from '../Components/MobileBottomNav';

const AppLayout = () => {
  const { authUser } = useAuth();
  const isStudent = authUser?.activeSession?.roleCode === 'STUDENT';

  return (
    <div className={`container mt-5${isStudent ? ' pb-5 pb-lg-0' : ''}`}>
      <Outlet />
      {isStudent && <MobileBottomNav />}
    </div>
  );
};

export default AppLayout;
